import { ReactNode, CSSProperties } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

export type HelperProps = {
  /** Helper type */
  type?: 'info' | 'success' | 'warning' | 'error';
  /** Set the amount of margin in the helper */
  margin?: CSSProperties['margin'];
  children: ReactNode;
  testId: string;
};

export const Helper = ({ type = 'info', margin = '0', children, testId }: HelperProps) => {
  return (
    <div className={cn(styles.root, styles[type])} style={{ margin }} data-testid={testId}>
      {children}
    </div>
  );
};
